import React, { useState, useEffect, useRef } from 'react';
import './App.css';
import { speak, enableVoice, stopSpeak } from "./voice";
import { voicePrompts } from "./voicePrompts";

// ─── ALAPÉRTELMEZETT TERMÉKEK (admin felületről felülírható) ──────────────────
const DEFAULT_SIZES = [
  { id: 'medium', emoji: '🍦',   name: 'Közepes', desc: '2 gömb',  price: 690 },
  { id: 'large',  emoji: '🍦🍦', name: 'Nagy',    desc: '3 gömb',  price: 890 },
];
const DEFAULT_FLAVORS = [
  { id: 'vanilla', emoji: '🤍', name: 'Vanília', desc: 'Klasszikus krémes vanília', doseTimes: { medium: 40, large: 60 } },
  { id: 'choco',   emoji: '🍫', name: 'Csoki',   desc: 'Belga csokoládé, intenzív', doseTimes: { medium: 45, large: 55 } },
  { id: 'mixed',   emoji: '🌀', name: 'Vegyes',  desc: 'Vanília + csoki 50/50', doseTimes: { medium: 40, large: 60 } },
];
const DEFAULT_SAUCES = [
  { id: 'none',   emoji: '🚫', name: 'Nem kérek', desc: 'Öntet nélkül',     price: 0   },
  { id: 'sauce1', emoji: '🍓', name: 'Eper',       desc: 'Friss eperöntet',  price: 150 },
  { id: 'sauce2', emoji: '🍫', name: 'Csoki',      desc: 'Meleg csokiöntet', price: 150 },
];
const DEFAULT_TOPPINGS = [
  { id: 'none',      emoji: '🚫', name: 'Nem kérek',    desc: 'Szórás nélkül',    price: 0   },
  { id: 'sprinkle1', emoji: '🌈', name: 'Színes szórás', desc: 'Cukorka szórás',   price: 100 },
  { id: 'sprinkle2', emoji: '🍪', name: 'Keksz szórás',  desc: 'Omlós kekszmorzsa',price: 120 },
];

const KIOSK_STEPS  = ['Kezdés','Íz','Öntet','Szórás','Kosár','Fizetés','Nyugta','Készítés','Kész'];
const ONLINE_STEPS = ['Kezdés','Íz','Öntet','Szórás','Kosár','Email','Fizetés','Kész'];

function fmt(n) { return n.toLocaleString('hu-HU') + ' Ft'; }

// ─── TERMÉKEK BETÖLTÉSE (admin API-ból, fallback: default) ───────────────────
function useProducts() {
  const [sizes,    setSizes]    = useState(DEFAULT_SIZES);
  const [flavors,  setFlavors]  = useState(DEFAULT_FLAVORS);
  const [sauces,   setSauces]   = useState(DEFAULT_SAUCES);
  const [toppings, setToppings] = useState(DEFAULT_TOPPINGS);

  useEffect(() => {
    fetch('/api/admin/products')
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!data) return;
        if (data.sizes    && data.sizes.length)    setSizes(data.sizes);
        if (data.flavors  && data.flavors.length)  setFlavors(data.flavors);
        if (data.sauces   && data.sauces.length)   setSauces(data.sauces);
        if (data.toppings && data.toppings.length) setToppings(data.toppings);
      })
      .catch(() => {});
  }, []);

  return { sizes, flavors, sauces, toppings };
}

// ─── EGYSÉGES VÁLASZTÓ KÁRTYÁK ────────────────────────────────────────────────
function ChoiceGrid({ items, selected, onSelect, cols = 3 }) {
  return (
    <div className={`option-grid${cols === 2 ? ' two' : ' three'}`} style={{ marginTop: 32 }}>
      {items.map(item => (
        <button key={item.id}
          className={`option-card${selected?.id === item.id ? ' selected' : ''}`}
          onClick={() => onSelect(item)}>
          <div>
            <div style={{ fontSize: 40, marginBottom: 8 }}>{item.emoji}</div>
            <div className="option-title">{item.name}</div>
            <div className="option-subtitle">{item.desc}</div>
          </div>
          {item.price !== undefined && (
            <div className="option-price">
              {item.price === 0 ? 'ingyenes' : item.id === 'none' ? 'ingyenes' : '+' + fmt(item.price)}
            </div>
          )}
          {item.price === undefined && <div className="option-price">{fmt(item.price || 0)}</div>}
        </button>
      ))}
    </div>
  );
}

// ─── KIOSK NYITÓKÉPERNYŐ ──────────────────────────────────────────────────────

// ─── ONLINE KEZDŐKÉPERNYŐ ─────────────────────────────────────────────────────
function OnlineHomeScreen({ onNewOrder }) {
  return (
    <div className="center-stage" style={{ height:'100%', minHeight:0, overflow:'hidden',
      padding:'clamp(8px,2vh,24px) clamp(10px,2vw,32px)', alignItems:'center' }}>
      <div style={{ textAlign:'center', width:'100%', maxWidth:980, height:'100%', maxHeight:'100%',
        margin:'0 auto', display:'flex', flexDirection:'column', justifyContent:'center',
        gap:'clamp(8px,1.5vh,18px)' }}>
        <div style={{ background:'linear-gradient(145deg,rgba(255,255,255,0.075),rgba(255,255,255,0.025))',
          border:'1px solid rgba(255,255,255,0.09)', borderRadius:'clamp(18px,3vw,34px)',
          padding:'clamp(14px,3vh,34px)', boxShadow:'0 18px 55px rgba(0,0,0,0.30)',
          maxHeight:'100%', overflow:'hidden' }}>

          <div style={{ fontSize:'clamp(42px,8vh,78px)', marginBottom:'clamp(4px,1vh,8px)', lineHeight:1 }}>🍦</div>

          <h1 style={{ margin:0, fontSize:'clamp(36px,7vh,70px)', lineHeight:0.95,
            letterSpacing:'-0.055em', background:'linear-gradient(135deg,#06b6d4,#7c3aed)',
            WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent' }}>
            CsavarOS
          </h1>

          <div style={{ color:'#cbd5e1', fontSize:'clamp(13px,2.2vh,22px)', lineHeight:1.25,
            maxWidth:720, margin:'clamp(6px,1.5vh,14px) auto 0' }}>
            Robot fagyizó – rendeld meg előre, fizess online, vedd át a helyszínen.
          </div>

          <div style={{ marginTop:'clamp(12px,2.6vh,28px)', display:'grid',
            gridTemplateColumns:'repeat(3,minmax(0,1fr))', gap:'clamp(8px,1.5vw,18px)' }}>
            {[
              { icon:'🛒', step:'1.', title:'Rendelj', desc:'Válaszd ki a fagylaltot.' },
              { icon:'💳', step:'2.', title:'Fizess', desc:'Kódot kapsz emailben.' },
              { icon:'🎫', step:'3.', title:'Váltsd be', desc:'A robot elkészíti.' }
            ].map((s,i) => (
              <div key={i} style={{ minHeight:'clamp(100px,18vh,170px)', padding:'clamp(10px,2vh,22px)',
                borderRadius:'clamp(16px,2.5vw,26px)', background:'rgba(255,255,255,0.055)',
                border:'1px solid rgba(255,255,255,0.085)', textAlign:'center', overflow:'hidden' }}>
                <div style={{ fontSize:'clamp(26px,5vh,42px)', lineHeight:1, marginBottom:'clamp(5px,1vh,10px)' }}>{s.icon}</div>
                <div style={{ color:'#67e8f9', fontSize:'clamp(10px,1.5vh,13px)', fontWeight:900, letterSpacing:'0.12em' }}>{s.step} LÉPÉS</div>
                <div style={{ color:'white', fontSize:'clamp(14px,2.3vh,22px)', fontWeight:900, marginTop:2 }}>{s.title}</div>
                <div style={{ color:'#94a3b8', fontSize:'clamp(11px,1.7vh,15px)', lineHeight:1.25, marginTop:4 }}>{s.desc}</div>
              </div>
            ))}
          </div>

          <div className="online-home-cta" style={{ marginTop:'clamp(12px,2.6vh,30px)',
            display:'grid', gridTemplateColumns:'minmax(240px,1fr) auto',
            gap:'clamp(10px,2vw,20px)', alignItems:'center' }}>
            <button onClick={onNewOrder} style={{ width:'100%', minHeight:'clamp(52px,8vh,76px)',
              padding:'clamp(12px,2vh,18px) clamp(18px,2vw,28px)', borderRadius:'clamp(16px,2.5vw,24px)',
              border:'none', background:'linear-gradient(135deg,#7c3aed,#06b6d4)', color:'white',
              fontSize:'clamp(17px,2.6vh,26px)', fontWeight:950, cursor:'pointer',
              boxShadow:'0 14px 38px rgba(6,182,212,0.24)' }}>
              🛒 Rendelés indítása
            </button>
            <div style={{ textAlign:'right', color:'#94a3b8', fontSize:'clamp(11px,1.7vh,14px)',
              lineHeight:1.35, minWidth:230 }}>
              <div>🎫 Kód emailben</div>
              <div>⏱️ 5 napig érvényes</div>
              <div>📍 Hatvan, Grassalkovich út 12.</div>
            </div>
          </div>

          <div style={{ marginTop:'clamp(8px,1.5vh,18px)', display:'flex', gap:'clamp(8px,2vw,18px)',
            justifyContent:'center', alignItems:'center', flexWrap:'wrap',
            fontSize:'clamp(11px,1.6vh,14px)', lineHeight:1.2 }}>
            <a href="/docs/aszf.pdf" target="_blank" rel="noreferrer"
              style={{ color:'#94a3b8', textDecoration:'underline', padding:'4px 6px' }}>📄 ÁSZF</a>
            <a href="/docs/gdpr.pdf" target="_blank" rel="noreferrer"
              style={{ color:'#94a3b8', textDecoration:'underline', padding:'4px 6px' }}>🔒 Adatkezelés</a>
          </div>
        </div>
      </div>
    </div>
  );
}

function KioskHomeScreen({ onNewOrder, onHaveCode }) {
  return (
    <div className="center-stage">
      <div style={{ textAlign: 'center', width: '100%', maxWidth: 900 }}>

        <div style={{ fontSize: 100, marginBottom: 16 }}>🍦</div>
        <h1 style={{ color: 'white', fontSize: 72, margin: '0 0 16px',
                     letterSpacing: '-0.04em', lineHeight: 1 }}>
          CsavarOS
        </h1>
        <div style={{ color: '#94a3b8', fontSize: 24, marginBottom: 56 }}>
          Robot fagyizó – érintsd meg a választást
        </div>

        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 32, padding: '0 32px' }}>

          {/* ÚJ RENDELÉS */}
          <button onClick={onNewOrder} style={{
            background: 'linear-gradient(135deg, #7c3aed, #06b6d4)',
            border: 'none', borderRadius: 32, padding: '48px 32px',
            color: 'white', cursor: 'pointer', textAlign: 'center',
            boxShadow: '0 20px 60px rgba(6,182,212,0.3)',
            transition: 'transform 0.15s ease'
          }}
          onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
          onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
          onTouchStart={e => e.currentTarget.style.transform = 'scale(0.97)'}
          onTouchEnd={e => e.currentTarget.style.transform = 'scale(1)'}>
            <div style={{ fontSize: 64 }}>🛒</div>
            <div style={{ fontSize: 36, fontWeight: 900, marginTop: 16 }}>Új rendelés</div>
            <div style={{ fontSize: 20, opacity: 0.8, marginTop: 8 }}>
              Válassz ízeket és fizess
            </div>
          </button>

          {/* VAN KÓDOM */}
          <button onClick={onHaveCode} style={{
            background: 'rgba(255,255,255,0.07)',
            border: '2px solid rgba(103,232,249,0.5)',
            borderRadius: 32, padding: '48px 32px',
            color: 'white', cursor: 'pointer', textAlign: 'center',
            transition: 'transform 0.15s ease'
          }}
          onMouseDown={e => e.currentTarget.style.transform = 'scale(0.97)'}
          onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}
          onTouchStart={e => e.currentTarget.style.transform = 'scale(0.97)'}
          onTouchEnd={e => e.currentTarget.style.transform = 'scale(1)'}>
            <div style={{ fontSize: 64 }}>🎫</div>
            <div style={{ fontSize: 36, fontWeight: 900, marginTop: 16 }}>Van kódom</div>
            <div style={{ fontSize: 20, opacity: 0.8, marginTop: 8 }}>
              Már előre rendeltem és fizettem
            </div>
          </button>

        </div>
      </div>
    </div>
  );
}

// ─── KÓD BEVÁLTÓ KÉPERNYŐ ────────────────────────────────────────────────────
function CodeRedeemScreen({ onBack, onSuccess }) {
  const [code,    setCode]    = useState('');
  const [status,  setStatus]  = useState('idle'); // idle | loading | error | success
  const [errMsg,  setErrMsg]  = useState('');
  const [order,   setOrder]   = useState(null);

  useEffect(() => {
    speak(voicePrompts.haveCode);
  }, []);

  // Numerikus billentyűzet
  function pressKey(key) {
    if (code.length < 6) setCode(c => c + key);
  }
  function deleteLast() { setCode(c => c.slice(0, -1)); }
  function clear()      { setCode(''); setStatus('idle'); setErrMsg(''); }

  async function redeem() {
    if (code.length !== 6) {
      speak(voicePrompts.codeInvalid);
      return;
    }
    speak(voicePrompts.codeChecking);
    setStatus('loading');
    try {
      const res  = await fetch('/api/redeem', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body:    JSON.stringify({ code })
      });
      const data = await res.json();
      if (res.ok && data.success) {
        speak(voicePrompts.codeAccepted);
        setOrder(data);
        setStatus('success');
        setTimeout(() => onSuccess(data), 2000); // 2mp után indul a robot
      } else {
        speak(voicePrompts.codeInvalid);
        setErrMsg(data.error || 'Érvénytelen kód');
        setStatus('error');
        setTimeout(() => { setStatus('idle'); setErrMsg(''); setCode(''); }, 3000);
      }
    } catch (e) {
      speak(voicePrompts.error);
      setErrMsg('Kapcsolódási hiba');
      setStatus('error');
      setTimeout(() => { setStatus('idle'); setErrMsg(''); }, 3000);
    }
  }

  const KEYS = ['1','2','3','4','5','6','7','8','9','⌫','0','OK'];

  return (
    <div className="center-stage">
      <div style={{ textAlign:'center', width:'100%', maxWidth:520 }}>

        <div style={{ fontSize:56, marginBottom:8 }}>🎫</div>
        <div style={{ color:'white', fontSize:36, fontWeight:900, marginBottom:8 }}>
          Add meg a kódod
        </div>
        <div style={{ color:'#94a3b8', fontSize:18, marginBottom:32 }}>
          A 6 jegyű kódot online rendeléskor kaptad
        </div>

        {/* Kód kijelző */}
        <div style={{
          display:'flex', justifyContent:'center', gap:12,
          marginBottom:32
        }}>
          {[0,1,2,3,4,5].map(i => (
            <div key={i} style={{
              width:64, height:80, borderRadius:16,
              background: code[i] ? 'rgba(103,232,249,0.15)' : 'rgba(255,255,255,0.05)',
              border: `2px solid ${code[i] ? 'rgba(103,232,249,0.6)' : 'rgba(255,255,255,0.1)'}`,
              display:'flex', alignItems:'center', justifyContent:'center',
              fontSize:40, fontWeight:900, color:'white'
            }}>
              {code[i] || ''}
            </div>
          ))}
        </div>

        {/* Hiba / siker üzenet */}
        {status === 'error' && (
          <div style={{ color:'#f87171', fontSize:20, marginBottom:16, fontWeight:700 }}>
            ❌ {errMsg}
          </div>
        )}
        {status === 'success' && (
          <div style={{ color:'#4ade80', fontSize:22, marginBottom:16, fontWeight:700 }}>
            ✅ Kód elfogadva! Robot indul…
          </div>
        )}
        {status === 'loading' && (
          <div style={{ color:'#67e8f9', fontSize:20, marginBottom:16 }}>
            Ellenőrzés…
          </div>
        )}

        {/* Numerikus billentyűzet */}
        <div style={{
          display:'grid', gridTemplateColumns:'repeat(3, 1fr)',
          gap:12, marginBottom:24
        }}>
          {KEYS.map(key => (
            <button key={key}
              onClick={() => {
                if (key === '⌫') deleteLast();
                else if (key === 'OK') redeem();
                else pressKey(key);
              }}
              disabled={status === 'loading' || status === 'success'}
              style={{
                padding:'20px 0',
                borderRadius:16,
                fontSize: key === 'OK' ? 22 : 32,
                fontWeight:900,
                border:'none',
                cursor:'pointer',
                background: key === 'OK'
                  ? 'linear-gradient(135deg, #7c3aed, #06b6d4)'
                  : key === '⌫'
                    ? 'rgba(248,113,113,0.15)'
                    : 'rgba(255,255,255,0.07)',
                color: key === '⌫' ? '#fca5a5' : 'white',
                opacity: status === 'loading' || status === 'success' ? 0.5 : 1
              }}>
              {key === 'OK' ? '✓ Beváltom' : key}
            </button>
          ))}
        </div>

        <button onClick={onBack} style={{
          background:'transparent', border:'none',
          color:'#94a3b8', fontSize:18, cursor:'pointer', textDecoration:'underline'
        }}>
          ← Vissza a főoldalra
        </button>
      </div>
    </div>
  );
}

// ─── LÉPÉS KOMPONENSEK ────────────────────────────────────────────────────────
function StartOrderStep({ size, onStart, onBackHome, isKiosk }) {
  return (
    <div className="center-stage" style={{
      minHeight: 0,
      padding: 'clamp(12px,2.4vh,28px)',
      alignItems: 'center'
    }}>
      <div style={{
        width: '100%',
        maxWidth: 1040,
        display: 'grid',
        gridTemplateColumns: 'minmax(0,1.1fr) minmax(280px,0.9fr)',
        gap: 'clamp(18px,3vw,42px)',
        alignItems: 'center'
      }}>
        <div>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 10,
            padding: '10px 16px',
            borderRadius: 999,
            background: 'rgba(103,232,249,0.10)',
            border: '1px solid rgba(103,232,249,0.24)',
            color: '#67e8f9',
            fontWeight: 900,
            fontSize: 'clamp(13px,1.7vh,16px)',
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            marginBottom: 'clamp(18px,3vh,34px)'
          }}>
            <span>🍦</span>
            Egy méret, gyors rendelés
          </div>

          <h1 style={{
            margin: 0,
            color: 'white',
            fontSize: 'clamp(46px,8vh,86px)',
            lineHeight: 0.95,
            letterSpacing: '-0.055em'
          }}>
            Készülhet a csavart fagyi?
          </h1>

          <p style={{
            color: '#cbd5e1',
            fontSize: 'clamp(18px,2.5vh,28px)',
            lineHeight: 1.28,
            maxWidth: 680,
            margin: 'clamp(16px,2.5vh,28px) 0 0'
          }}>
            Most egy fix mérettel dolgozunk. Válaszd ki az ízt, az öntetet és a szórást, a robot pedig elkészíti.
          </p>

          {size && (
            <div style={{
              marginTop: 'clamp(18px,3vh,32px)',
              display: 'inline-flex',
              alignItems: 'center',
              gap: 14,
              padding: '14px 18px',
              borderRadius: 20,
              background: 'rgba(255,255,255,0.07)',
              border: '1px solid rgba(255,255,255,0.10)',
              color: 'white'
            }}>
              <div style={{ fontSize: 34 }}>{size.emoji || '🍦'}</div>
              <div style={{ textAlign: 'left' }}>
                <div style={{ color: '#94a3b8', fontSize: 13, fontWeight: 800, textTransform: 'uppercase', letterSpacing: '0.08em' }}>
                  Aktuális méret
                </div>
                <div style={{ fontSize: 22, fontWeight: 950 }}>
                  {size.name} {size.price !== undefined ? `· ${fmt(size.price)}` : ''}
                </div>
              </div>
            </div>
          )}
        </div>

        <div style={{
          borderRadius: 32,
          padding: 'clamp(22px,3.5vh,38px)',
          background: 'linear-gradient(145deg, rgba(124,58,237,0.22), rgba(6,182,212,0.13))',
          border: '1px solid rgba(255,255,255,0.12)',
          boxShadow: '0 24px 70px rgba(0,0,0,0.28)',
          textAlign: 'center'
        }}>
          <div style={{
            width: 'clamp(150px,20vh,210px)',
            height: 'clamp(150px,20vh,210px)',
            margin: '0 auto clamp(18px,3vh,30px)',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: 'clamp(76px,11vh,120px)',
            background: 'radial-gradient(circle at 35% 25%, rgba(255,255,255,0.28), rgba(255,255,255,0.06) 42%, rgba(6,182,212,0.16))',
            border: '1px solid rgba(255,255,255,0.14)'
          }}>
            🍦
          </div>

          <button className="primary-action big" onClick={onStart} style={{
            width: '100%',
            minHeight: 82,
            fontSize: 'clamp(24px,3.4vh,36px)',
            borderRadius: 24
          }}>
            Rendelés indítása →
          </button>

          {isKiosk && (
            <button className="secondary-action big" onClick={onBackHome} style={{
              width: '100%',
              marginTop: 16,
              minHeight: 62
            }}>
              ← Főoldal
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function FlavorStep({ flavors, selected, onSelect }) {
  return (
    <div>
      <div className="hero-copy">
        <div className="eyebrow">2. lépés</div>
        <h1>Válassz ízt</h1>
        <p>Melyik fagylaltot kéred?</p>
      </div>
      <ChoiceGrid items={flavors} selected={selected} onSelect={onSelect} cols={3} />
    </div>
  );
}

function SauceStep({ sauces, selected, onSelect }) {
  return (
    <div>
      <div className="hero-copy">
        <div className="eyebrow">3. lépés</div>
        <h1>Öntet</h1>
        <p>Kérsz öntetet?</p>
      </div>
      <ChoiceGrid items={sauces} selected={selected} onSelect={onSelect} cols={3} />
    </div>
  );
}

function ToppingStep({ toppings, selected, onSelect }) {
  return (
    <div>
      <div className="hero-copy">
        <div className="eyebrow">4. lépés</div>
        <h1>Szórás</h1>
        <p>Kérsz szórást?</p>
      </div>
      <ChoiceGrid items={toppings} selected={selected} onSelect={onSelect} cols={3} />
    </div>
  );
}

function CartStep({ items, onRemove, coupon, onCouponApply, isKiosk = false }) {
  const rawTotal = items.reduce((s, i) => s + i.total, 0);
  const discount = coupon ? Math.round(rawTotal * coupon.discount / 100) : 0;
  const total = rawTotal - discount;
  const [couponInput, setCouponInput] = React.useState('');
  const [couponStatus, setCouponStatus] = React.useState('');
  const [couponLoading, setCouponLoading] = React.useState(false);
  const [couponPadOpen, setCouponPadOpen] = React.useState(false);

  const addCouponDigit = (digit) => {
    setCouponStatus('');
    setCouponInput(prev => {
      const onlyDigits = String(prev || '').replace(/\D/g, '').slice(0, 4);
      if (onlyDigits.length >= 4) return onlyDigits;
      return (onlyDigits + String(digit)).slice(0, 4);
    });
  };

  const removeCouponDigit = () => {
    setCouponStatus('');
    setCouponInput(prev => String(prev || '').replace(/\D/g, '').slice(0, -1));
  };

  const clearCouponInput = () => {
    setCouponStatus('');
    setCouponInput('');
  };

  const closeCouponPadLater = () => {
    if (!isKiosk) return;
    setTimeout(() => {
      setCouponPadOpen(false);
      setCouponStatus('');
      setCouponInput('');
    }, 5000);
  };

  async function validateCoupon() {
    if (!couponInput.trim()) return;

    if (isKiosk && !/^\d{4}$/.test(couponInput.trim())) {
      setCouponStatus('Kérlek, adj meg 4 számjegyet');
      return;
    }
    setCouponLoading(true);
    setCouponStatus('');
    try {
      const res = await fetch('/api/coupon/validate', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ code: couponInput.trim() })
      });
      const data = await res.json();
      if (data.valid) {
        const appliedCoupon = {
          ...data,
          code: data.code || couponInput.trim().toUpperCase()
        };

        onCouponApply(appliedCoupon);

        try {
          sessionStorage.setItem('csavarosCoupon', JSON.stringify(appliedCoupon));
        } catch (e) {}

        setCouponStatus('ok');

        if (isKiosk) {
          setCouponPadOpen(false);
          setCouponInput('');
        }
      } else {
        setCouponStatus(data.error || 'Érvénytelen kód');
        closeCouponPadLater();
      }
    } catch(e) {
      setCouponStatus('Hiba történt');
    }
    setCouponLoading(false);
  }

  return (
    <div>
      <div className="page-title-block">
        <div className="eyebrow">5. lépés</div>
        <h1>Kosár</h1>
        <p>Ellenőrizd a rendelésed!</p>
      </div>
      {items.length === 0
        ? <div className="large-empty" style={{ marginTop:32 }}>A kosár üres.</div>
        : (
          <div className="cart-page-list">
            {items.map((item, idx) => (
              <div className="cart-page-item" key={idx}>
                <div className="cart-page-index">{idx+1}</div>
                <div className="cart-page-icon">🍦</div>
                <div>
                  <div className="cart-page-title">{item.size.name} – {item.flavor.name}</div>
                  <div className="cart-page-lines">
                    {item.sauce.id   !== 'none' ? item.sauce.name   : 'Öntet nélkül'} &bull;{' '}
                    {item.topping.id !== 'none' ? item.topping.name : 'Szórás nélkül'}
                  </div>
                </div>
                <div className="cart-page-price">{fmt(item.total)}</div>
                <button className="remove-wide-btn" onClick={() => onRemove(idx)}>✕</button>
              </div>
            ))}

            {/* KUPONKÓD */}
            <div className="coupon-area">
              {!coupon ? (
                isKiosk ? (
                  <>
                    <button
                      type="button"
                      className="coupon-open-btn"
                      onClick={() => {
                        setCouponStatus('');
                        setCouponInput('');
                        setCouponPadOpen(true);
                      }}
                    >
                      🎟️ Kupon megadása
                    </button>

                    {couponPadOpen && (
                      <div className="coupon-modal-backdrop">
                        <div className="coupon-modal">
                          <div className="coupon-modal-title">Kuponkód</div>
                          <div className="coupon-modal-subtitle">Add meg a 4 számjegyű kódot</div>

                          <div className="kiosk-coupon-display">
                            {couponInput ? couponInput.padEnd(4, '•') : '••••'}
                          </div>

                          <div className="kiosk-numpad">
                            {[1,2,3,4,5,6,7,8,9].map(n => (
                              <button key={n} type="button" onClick={() => addCouponDigit(n)}>
                                {n}
                              </button>
                            ))}

                            <button type="button" className="numpad-muted" onClick={clearCouponInput}>
                              C
                            </button>
                            <button type="button" onClick={() => addCouponDigit(0)}>
                              0
                            </button>
                            <button type="button" className="numpad-muted" onClick={removeCouponDigit}>
                              ⌫
                            </button>
                          </div>

                          {couponStatus && couponStatus !== 'ok' && (
                            <div className="coupon-modal-error">❌ {couponStatus}</div>
                          )}

                          <div className="coupon-modal-actions">
                            <button
                              type="button"
                              className="coupon-cancel-btn"
                              onClick={() => {
                                setCouponPadOpen(false);
                                setCouponStatus('');
                                setCouponInput('');
                              }}
                            >
                              Mégse
                            </button>

                            <button
                              type="button"
                              className="coupon-apply-btn"
                              onClick={validateCoupon}
                              disabled={couponLoading || couponInput.length !== 4}
                            >
                              {couponLoading ? '...' : 'Beváltás'}
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                  </>
                ) : (
                  <div style={{ display:'flex', gap:8 }}>
                    <input
                      type="text"
                      value={couponInput}
                      onChange={e => setCouponInput(e.target.value.toUpperCase())}
                      onKeyDown={e => e.key === 'Enter' && validateCoupon()}
                      placeholder="Kuponkód"
                      style={{ flex:1, padding:'10px 14px', borderRadius:10, border:'1px solid rgba(103,232,249,0.3)',
                        background:'rgba(255,255,255,0.05)', color:'white', fontSize:16, fontFamily:'inherit' }}
                    />
                    <button className="btn-success" onClick={validateCoupon} disabled={couponLoading}
                      style={{ padding:'10px 18px', borderRadius:10, border:'none', cursor:'pointer',
                        background:'rgba(34,197,94,0.2)', color:'#86efac', fontWeight:700, fontSize:15 }}>
                      {couponLoading ? '...' : 'Beváltás'}
                    </button>
                  </div>
                )
              ) : (
                <div className="coupon-applied-box">
                  <span>✅ {coupon.code} – {coupon.discount}% kedvezmény</span>
                  <button
                    type="button"
                    onClick={() => {
                      onCouponApply(null);
                      try { sessionStorage.removeItem('csavarosCoupon'); } catch(e) {}
                      setCouponInput('');
                      setCouponStatus('');
                      setCouponPadOpen(false);
                    }}
                  >
                    ✕
                  </button>
                </div>
              )}

              {!isKiosk && couponStatus && couponStatus !== 'ok' && (
                <div style={{ color:'#fca5a5', fontSize:14, marginTop:6 }}>❌ {couponStatus}</div>
              )}
            </div>

            {/* ÖSSZESÍTŐ */}
            <div style={{ padding:'10px 18px' }}>
              {coupon && (
                <>
                  <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:4 }}>
                    <span style={{ color:'#94a3b8', fontSize:16, marginRight:24 }}>Eredeti ár:</span>
                    <span style={{ color:'#94a3b8', fontSize:16, textDecoration:'line-through' }}>{fmt(rawTotal)}</span>
                  </div>
                  <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:4 }}>
                    <span style={{ color:'#86efac', fontSize:16, marginRight:24 }}>Kedvezmény ({coupon.discount}%):</span>
                    <span style={{ color:'#86efac', fontSize:16 }}>-{fmt(discount)}</span>
                  </div>
                </>
              )}
              <div style={{ display:'flex', justifyContent:'flex-end' }}>
                <span style={{ color:'#94a3b8', fontSize:20, marginRight:24 }}>Összesen:</span>
                <span style={{ color:'white', fontSize:36, fontWeight:900 }}>{fmt(total)}</span>
              </div>
            </div>
          </div>
        )}
    </div>
  );
}

function EmailStep({ email, onChange }) {
  return (
    <div style={{ padding:'8px 0' }}>
      <div className="hero-copy">
        <div className="eyebrow">Email cím</div>
        <h1 style={{ fontSize:36 }}>Hova küldjük a kódot?</h1>
        <p>Sikeres fizetés után erre a címre küldjük a beváltó kódot.</p>
      </div>
      <input type="email" value={email} onChange={e => onChange(e.target.value)}
        placeholder="pelda@email.com"
        style={{ marginTop:24, width:'100%', maxWidth:520, padding:'16px 20px',
          fontSize:20, borderRadius:14, border:'2px solid rgba(103,232,249,0.5)',
          background:'rgba(255,255,255,0.07)', color:'white', outline:'none',
          fontFamily:'inherit', boxSizing:'border-box', display:'block' }} />
    </div>
  );
}

// ─── FIZETÉS ──────────────────────────────────────────────────────────────────
function PaymentStep({ cart, total, coupon, customerEmail, isOnline, isKiosk, orderRef: initOrderRef, onPaid, onError }) {
  const [status,   setStatus]   = useState(initOrderRef ? 'polling' : 'initiating');
  const [qrUrl,    setQrUrl]    = useState(null);
  const [timeLeft, setTimeLeft] = useState(600);
  const [currentOrderRef, setCurrentOrderRef] = useState(initOrderRef || null);
  const pollRef  = useRef(null);
  const timerRef = useRef(null);

  useEffect(() => {
    if (initOrderRef) startPolling(initOrderRef);
    else              initiatePayment();
    return () => { clearInterval(pollRef.current); clearInterval(timerRef.current); };
  // eslint-disable-next-line
  }, []);

  async function initiatePayment() {
    setStatus('initiating');
    try {
      if (isKiosk) {
        // KIOSK → qvik QR kód
        const effectiveCoupon = coupon || null;

        console.log('QVIK coupon debug:', effectiveCoupon);

        const res  = await fetch('/api/payment/start-qvik', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ cart, total, coupon: effectiveCoupon, isOnline })
        });
        const data = await res.json();
        if (data.qrUrl && data.orderRef) {
          setCurrentOrderRef(data.orderRef);
          setQrUrl(data.qrUrl);
          setStatus('waiting');
          let t = 600;
          timerRef.current = setInterval(() => {
            t--; setTimeLeft(t);
            if (t <= 0) { clearInterval(timerRef.current); setStatus('error'); onError(); }
          }, 1000);
          startPolling(data.orderRef);
        } else { setStatus('error'); onError(); }
      } else {
        // WEB → SimplePay teljes oldal
        const res  = await fetch('/api/payment/start', {
          method:'POST', headers:{'Content-Type':'application/json'},
          body: JSON.stringify({ cart, total, coupon, customerEmail, isOnline })
        });
        const data = await res.json();
        if (data.paymentUrl) {
          setQrUrl(`https://api.qrserver.com/v1/create-qr-code/?size=220x220&data=${encodeURIComponent(data.paymentUrl)}`);
          setStatus('redirect');
          let c = 5; setTimeLeft(c);
          timerRef.current = setInterval(() => {
            c--; setTimeLeft(c);
            if (c <= 0) { clearInterval(timerRef.current); window.location.href = data.paymentUrl; }
          }, 1000);
          startPolling(data.orderRef);
        } else { setStatus('error'); onError(); }
      }
    } catch (e) { setStatus('error'); onError(); }
  }

  function startPolling(ref) {
    let attempts = 0;
    pollRef.current = setInterval(async () => {
      attempts++;
      if (attempts > 300) { clearInterval(pollRef.current); setStatus('error'); onError(); return; }
      try {
        const res  = await fetch(`/api/payment/status/${ref}`);
        const data = await res.json();
        if (data.status === 'FINISHED' && (!isOnline || data.code)) {
          clearInterval(pollRef.current); clearInterval(timerRef.current);
          onPaid(data);
        } else if (['CANCELLED','NOTAUTHORIZED','TIMEOUT'].includes(data.status)) {
          clearInterval(pollRef.current); clearInterval(timerRef.current);
          setStatus('error'); onError();
        }
      } catch (_) {}
    }, 2000);
  }

  const mins = String(Math.floor(timeLeft / 60)).padStart(2,'0');
  const secs = String(timeLeft % 60).padStart(2,'0');

  return (
    <div className="center-stage">
      <div className="payment-card">

        {status === 'initiating' && (
          <>
            <div className="payment-icons">📱</div>
            <div className="pay-label">Fizetendő összeg</div>
            <div className="pay-value">{fmt(total)}</div>
            <div className="pay-subtext" style={{ marginTop:24 }}>QR kód generálása…</div>
            <div className="loaderWrap" style={{ marginTop:24 }}><div className="loader"/></div>
          </>
        )}

        {status === 'waiting' && qrUrl && (
          <>
            <div className="pay-label">Fizetendő összeg</div>
            <div className="pay-value" style={{ marginBottom:12 }}>{fmt(total)}</div>
            <div style={{ margin:'0 auto', width:280, height:280, borderRadius:20,
              overflow:'hidden', background:'white', padding:10,
              boxShadow:'0 0 50px rgba(103,232,249,0.25)' }}>
              <img src={qrUrl} alt="qvik QR" style={{ width:'100%', height:'100%' }}/>
            </div>
            <div className="pay-text" style={{ marginTop:14 }}>
              📱 Szkenneld be a banki applikációddal
            </div>
            <div className="pay-subtext">OTP, K&H, Raiffeisen, CIB, Erste, MBH…</div>
            <div style={{ color: timeLeft < 60 ? '#f87171' : '#67e8f9',
              fontSize:26, fontWeight:900, marginTop:12 }}>
              ⏱ {mins}:{secs}
            </div>
            <div style={{ color:'#94a3b8', fontSize:13, marginTop:4 }}>
              Fizetés az OTP SimplePay / qvik rendszerén keresztül
            </div>
            {currentOrderRef && (
              <button className="secondary-action big" style={{ marginTop:16, width:'100%',
                background:'rgba(245,158,11,0.15)', color:'#fde68a',
                border:'1px solid rgba(245,158,11,0.4)' }}
                onClick={async () => {
                  try {
                    await fetch('/api/payment/test-finish', {
                      method:'POST', headers:{'Content-Type':'application/json'},
                      body: JSON.stringify({ orderRef: currentOrderRef })
                    });
                  } catch(e) {}
                }}>
                🧪 Teszt: Fizetés szimulálása
              </button>
            )}
          </>
        )}

        {status === 'redirect' && (
          <>
            <div className="payment-icons">💳</div>
            <div className="pay-label">Fizetendő összeg</div>
            <div className="pay-value">{fmt(total)}</div>
            <div className="pay-text">Átirányítás a SimplePay-re… ({timeLeft}mp)</div>
            <div className="pay-subtext">Kártya, Apple Pay, Google Pay és más fizetési módok</div>
            <div className="loaderWrap" style={{ marginTop:24 }}><div className="loader"/></div>
          </>
        )}

        {status === 'polling' && (
          <>
            <div className="payment-icons">⏳</div>
            <div className="pay-text">Fizetés megerősítése…</div>
            <div className="pay-subtext">Kérjük várj!</div>
            <div className="loaderWrap" style={{ marginTop:24 }}><div className="loader"/></div>
          </>
        )}

      </div>
    </div>
  );
}

function PreparingStep({ cart, orderRef, onDone }) {
  const [progress, setProgress] = useState(12);
  const [machine, setMachine] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let stopped = false;
    let doneCalled = false;

    async function pollStatus() {
      if (!orderRef) {
        setError('Hiányzó rendelésazonosító');
        return;
      }

      try {
        const res = await fetch(`/api/orders/status/${orderRef}`);
        const data = await res.json();

        if (stopped) return;

        if (!res.ok || data.success === false) {
          setMachine(data);
          setProgress(p => Math.min(85, p + 3));
          return;
        }

        setMachine(data);

        if (data.status === 'error') {
          setError(data.error || 'A gyártás hibával leállt.');
          return;
        }

        if (data.readyToTake && !doneCalled) {
          doneCalled = true;
          setProgress(100);
          setTimeout(onDone, 800);
          return;
        }

        setProgress(p => Math.min(95, p + 2));
      } catch (_) {
        if (!stopped) setProgress(p => Math.min(80, p + 1));
      }
    }

    pollStatus();
    const t = setInterval(pollStatus, 2000);

    return () => {
      stopped = true;
      clearInterval(t);
    };
  }, [orderRef, onDone]);

  const item = cart?.[0];
  const statusText = error || machine?.standText || machine?.message || 'Gyártás folyamatban';

  return (
    <div className="center-stage">
      <div className="message-card">
        <div className="message-icon">{error ? '⚠️' : '🤖'}</div>
        <div className="message-title">{error ? 'Gyártási hiba' : 'A robot készíti a fagylaltod…'}</div>
        {item && <div className="prep-status" style={{ marginTop:8 }}>
          {item.size.name} {item.flavor.name}
          {item.sauce.id   !== 'none' ? ` · ${item.sauce.name}`   : ''}
          {item.topping.id !== 'none' ? ` · ${item.topping.name}` : ''}
        </div>}
        <div className="prep-status" style={{ marginTop:18, color: error ? '#fca5a5' : '#94a3b8' }}>
          {statusText}
        </div>
        <div className="progress-bar" style={{ marginTop:40 }}>
          <div className="progress-fill" style={{ width:`${progress}%` }}/>
        </div>
        <div style={{ color:'#67e8f9', fontSize:28, fontWeight:900, marginTop:16 }}>
          {error ? 'Kérj segítséget' : progress < 100 ? `${progress}%` : '✅ Kész!'}
        </div>
      </div>
    </div>
  );
}


// ─── KIOSK NYUGTA KÉPERNYŐ ────────────────────────────────────────────────────
function KioskReceiptStep({ orderRef, onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 20000);
    return () => clearTimeout(t);
  }, [onDone]);

  const downloadUrl = orderRef ? `https://csavaros.online/api/receipt/download/${orderRef}` : null;
  const qrUrl = downloadUrl ? `https://api.qrserver.com/v1/create-qr-code/?size=300x300&data=${encodeURIComponent(downloadUrl)}` : null;

  return (
    <div className="center-stage">
      <div className="message-card success" style={{ maxWidth:600, padding:32, textAlign:'center' }}>
        <div className="message-icon">🧾✅</div>
        <div className="message-title">Fizetés sikeres!</div>
        <div className="pay-subtext" style={{ marginBottom:24 }}>Olvasd be a QR kódot a nyugta letöltéséhez!</div>
        {qrUrl ? (
          <div style={{ margin:'0 auto', width:240, height:240, borderRadius:16,
            overflow:'hidden', background:'white', padding:8, boxShadow:'0 4px 20px rgba(0,0,0,0.15)' }}>
            <img src={qrUrl} alt="Nyugta QR" style={{ width:'100%', height:'100%' }}/>
          </div>
        ) : (
          <div style={{ color:'#94a3b8', fontSize:16, padding:40 }}>QR kód generálása...</div>
        )}
        <div style={{ color:'#64748b', fontSize:14, marginTop:16 }}>📱 Mobilodon töltsd le a nyugtát</div>
        <button className="primary-action big" style={{ marginTop:24, width:'100%' }} onClick={onDone}>
          🔄 Új rendelés
        </button>
        <div style={{ color:'#64748b', fontSize:13, marginTop:10 }}>20 másodperc múlva automatikusan visszatér</div>
      </div>
    </div>
  );
}

function SuccessStep({ orderCode, cart, receiptQrUrl, onRestart }) {
  const item = cart?.[0];
  return (
    <div className="center-stage">
      <div className="message-card success">
        <div className="message-icon">🍦✅</div>
        <div className="message-title">Jó étvágyat!</div>
        {item && <div className="prep-status" style={{ marginTop:8 }}>
          {item.size.name} {item.flavor.name}
          {item.sauce.id   !== 'none' ? ` · ${item.sauce.name}`   : ''}
          {item.topping.id !== 'none' ? ` · ${item.topping.name}` : ''}
        </div>}
        {receiptQrUrl && (
          <div style={{ marginTop:28 }}>
            <div className="pay-label" style={{ marginBottom:12 }}>🧾 Nyugta</div>
            <div style={{ margin:'0 auto', width:180, height:180, borderRadius:14,
              overflow:'hidden', background:'white', padding:6 }}>
              <img src={receiptQrUrl} alt="Nyugta" style={{ width:'100%', height:'100%' }}/>
            </div>
          </div>
        )}
        <button className="primary-action big" style={{ marginTop:36 }} onClick={onRestart}>
          🔄 Új rendelés
        </button>
      </div>
    </div>
  );
}

function OnlineConfirmStep({ code, orderRef }) {
  return (
    <div className="center-stage">
      <div className="message-card success" style={{ maxWidth:800, width:'100%' }}>
        <div className="message-icon">🎫✅</div>
        <div className="message-title">Rendelésed rögzítve!</div>
        <div className="pay-subtext" style={{ marginTop:8 }}>Váltsd be ezt a kódot a fagyizóban</div>

        {/* KÓD */}
        <div style={{ margin:'20px auto', background:'rgba(103,232,249,0.12)',
          border:'2px solid rgba(103,232,249,0.5)', borderRadius:20,
          padding:'16px 40px', display:'inline-block' }}>
          <div style={{ color:'#67e8f9', fontSize:52, fontWeight:900, letterSpacing:'0.14em' }}>
            {code}
          </div>
        </div>
        <div className="pay-subtext" style={{ marginTop:6 }}>5 napig érvényes</div>

        {/* NYUGTA */}
        {orderRef && (
          <div style={{ marginTop:24, width:'100%' }}>
            <div className="pay-label" style={{ marginBottom:10 }}>🧾 Nyugta</div>

            <a href={`/api/receipt/download/${orderRef}`}
              download
              style={{ display:'block', marginTop:12, padding:'18px 28px',
                background:'rgba(103,232,249,0.15)', color:'#67e8f9',
                border:'1px solid rgba(103,232,249,0.35)',
                borderRadius:14, textDecoration:'none', fontWeight:800,
                fontSize:18, textAlign:'center' }}>
              ⬇️ Nyugta letöltése PDF-ben
            </a>

            <div className="pay-subtext" style={{ marginTop:10 }}>
              A nyugta külön PDF fájlként nyílik meg / tölthető le.
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function ErrorStep({ payEvent, onRetry, onRestart }) {
  const msg = { cancel:'A fizetést megszakítottad.', timeout:'Lejárt a fizetési idő.',
    fail:'A kártyás fizetés nem sikerült.', error:'Technikai hiba történt.' }[payEvent]
    || 'A fizetés nem sikerült.';
  return (
    <div className="center-stage">
      <div className="message-card error">
        <div className="message-icon">❌</div>
        <div className="message-title">{msg}</div>
        <div className="bottom-nav" style={{ justifyContent:'center', marginTop:32 }}>
          <button className="primary-action big" onClick={onRetry}>🔄 Újra</button>
          <button className="secondary-action big" onClick={onRestart}>🏠 Főoldal</button>
        </div>
      </div>
    </div>
  );
}

function CartSidebar({ step, items, currentConfig }) {
  const total = items.reduce((s, i) => s + i.total, 0);
  const cur   = (currentConfig.size?.price||0)
              + (currentConfig.sauce?.price||0)
              + (currentConfig.topping?.price||0);
  return (
    <div className="cart-panel">
      <div className="cart-panel-header">
        <div>
          <div className="panel-eyebrow">Kosár</div>
          <div className="panel-title">{items.length} tétel</div>
        </div>
        <div className="mini-icon">🛒</div>
      </div>
        {currentConfig.size && step <= 3 && (
        <div className="current-preview">
          <div className="preview-line">📏 {currentConfig.size.name}</div>
          {currentConfig.flavor  && <div className="preview-line">🍦 {currentConfig.flavor.name}</div>}
          {currentConfig.sauce   && currentConfig.sauce.id   !== 'none' && <div className="preview-line">+ {currentConfig.sauce.name}</div>}
          {currentConfig.topping && currentConfig.topping.id !== 'none' && <div className="preview-line">+ {currentConfig.topping.name}</div>}
          {cur > 0 && <div className="preview-price">{fmt(cur)}</div>}
        </div>
      )}
      <div className="cart-divider"/>
      <div className="cart-list-header"><span>Tételek</span></div>
      <div className="cart-list">
        {items.length === 0
          ? <div className="empty-cart">A kosár üres.<br/>Indíts új rendelést!</div>
          : items.map((item, idx) => (
            <div className="cart-item" key={idx}>
              <div className="cart-item-icon">🍦</div>
              <div>
                <div className="cart-item-title">{item.size.name} – {item.flavor.name}</div>
                <div className="cart-item-lines">
                  {item.sauce.id   !== 'none' ? item.sauce.name   : 'Öntet nélkül'}<br/>
                  {item.topping.id !== 'none' ? item.topping.name : 'Szórás nélkül'}
                </div>
                <div className="cart-item-price">{fmt(item.total)}</div>
              </div>
            </div>
          ))
        }
      </div>
      <div className="cart-bottom">
        <div className="grand-total-row">
          <span>Összesen</span><strong>{fmt(total)}</strong>
        </div>
      </div>
    </div>
  );
}

function Topbar({ total, isOnline, isKiosk, screen, onHome }) {
  if (screen === 'home' || screen === 'redeem') return (
    <div className="topbar">
      <button className="brand-block" onClick={onHome}>
        <div className="brand-mark">🍦</div>
        <div>
          <div className="brand-title">CsavarOS</div>
          <div className="brand-subtitle">Robot Fagyizó</div>
        </div>
      </button>
      <div className="topbar-center">
        <div className="status-pill online">🟢 Üzlet nyitva</div>
      </div>
      <div className="topbar-total">
        <div className="topbar-total-label">Üdvözlünk!</div>
        <div className="topbar-total-value" style={{ fontSize:22 }}>csavaros.online</div>
      </div>
    </div>
  );
  return (
    <div className="topbar">
      <button className="brand-block" onClick={onHome}>
        <div className="brand-mark">🍦</div>
        <div>
          <div className="brand-title">CsavarOS</div>
          <div className="brand-subtitle">
            {isKiosk ? 'Kiosk' : isOnline ? 'Online rendelés' : 'Robot Fagyizó'}
          </div>
        </div>
      </button>
      <div className="topbar-center">
        <div className="status-pill online">🟢 Online</div>
        {isKiosk  && <div className="status-pill" style={{ color:'#bbf7d0' }}>🖥️ Kiosk</div>}
        {isOnline && <div className="status-pill" style={{ color:'#fde68a' }}>🌐 Web</div>}
      </div>
      <div className="topbar-total">
        <div className="topbar-total-label">Összesen</div>
        <div className="topbar-total-value">{fmt(total)}</div>
      </div>
    </div>
  );
}

function ProgressBar({ step, isOnline }) {
  const STEPS = isOnline ? ONLINE_STEPS : KIOSK_STEPS;
  return (
    <div className="progress-steps">
      {STEPS.map((label, i) => (
        <div key={i} className={`progress-step${step === i ? ' active' : ''}`}>
          <span>{i+1}</span>{label}
        </div>
      ))}
    </div>
  );
}

// ─── APP ROOT ─────────────────────────────────────────────────────────────────
export default function App() {
  const { sizes, flavors, sauces, toppings } = useProducts();

  // screen: 'home' | 'redeem' | 'order'
  const [screen,         setScreen]        = useState('home');
  const [step,           setStep]          = useState(0);
  const [size,           setSize]          = useState(null);
  const [flavor,         setFlavor]        = useState(null);
  const [sauce,          setSauce]         = useState(undefined);
  const [topping,        setTopping]       = useState(undefined);
  const [cart,           setCart]          = useState([]);
  const [email,          setEmail]         = useState('');
  const [payError,       setPayError]      = useState(false);
  const [payEvent,       setPayEvent]      = useState(null);
  const [receiptData,    setReceiptData]   = useState(null);
  const [codeRedeemMode, setCodeRedeemMode] = useState(false);
  const [returnOrderRef, setReturnOrderRef] = useState(null);
  const [isOnline,       setIsOnline]      = useState(false);
  const [isKiosk,        setIsKiosk]       = useState(false);
  const [coupon,         setCoupon]        = useState(null);
  const [couponDiscount, setCouponDiscount] = useState(0);

  const rawTotal   = cart.reduce((s, i) => s + i.total, 0);
  const couponDisc = coupon ? Math.round(rawTotal * coupon.discount / 100) : 0;
  const cartTotal  = rawTotal - couponDisc;
  const payStep    = isOnline ? 6 : 5;
  const showSidebar = screen === 'order' && step <= 4;
  const lastVoicePromptRef = useRef('');

  function speakOnce(key, text) {
    if (!text) return;
    if (lastVoicePromptRef.current === key) return;
    lastVoicePromptRef.current = key;
    speak(text);
  }

  useEffect(() => {
    if (screen !== 'order') return;

    if (payError) {
      speakOnce('pay-error', voicePrompts.error);
      return;
    }

    if (isOnline) {
      if (step === 0) speakOnce('online-step-0', voicePrompts.startOrder || voicePrompts.chooseProduct);
      if (step === 1) speakOnce('online-step-1', voicePrompts.chooseIcecream);
      if (step === 2) speakOnce('online-step-2', voicePrompts.chooseSauce);
      if (step === 3) speakOnce('online-step-3', voicePrompts.chooseTopping);
      if (step === 4) speakOnce('online-step-4', voicePrompts.reviewOrder);
      if (step === 5) speakOnce('online-step-5', voicePrompts.email || "Add meg az email címedet, ahová a beváltó kódot küldjük.");
      if (step === 6) speakOnce('online-step-6', voicePrompts.paymentChecking || voicePrompts.scanQr);
      if (step === 7) speakOnce('online-step-7', voicePrompts.finished);
      return;
    }

    // KIOSK LÉPÉSEK:
    // 0 Kezdés, fix méret automatikusan
    // 1 Íz
    // 2 Öntet
    // 3 Szórás
    // 4 Kosár
    // 5 Fizetés
    // 6 Nyugta
    // 7 Készítés / robot
    // 8 Kész
    if (step === 0) speakOnce('kiosk-step-0', voicePrompts.startOrder || voicePrompts.chooseProduct);
    if (step === 1) speakOnce('kiosk-step-1', voicePrompts.chooseIcecream);
    if (step === 2) speakOnce('kiosk-step-2', voicePrompts.chooseSauce);
    if (step === 3) speakOnce('kiosk-step-3', voicePrompts.chooseTopping);
    if (step === 4) speakOnce('kiosk-step-4', voicePrompts.reviewOrder);
    if (step === 5) speakOnce('kiosk-step-5', voicePrompts.scanQr);
    if (step === 6) speakOnce('kiosk-step-6', voicePrompts.receipt);
    if (step === 7) speakOnce('kiosk-step-7', voicePrompts.robotWorking);
    if (step === 8) speakOnce('kiosk-step-8', voicePrompts.finished);
  }, [screen, step, isOnline, payError]);

  useEffect(() => {
    const params   = new URLSearchParams(window.location.search);
    const payment  = params.get('payment');
    const orderRef = params.get('orderRef');
    const mode     = params.get('mode');
    const kiosk    = params.get('kiosk');

    const isKioskMode  = kiosk === 'true';
    const isOnlineMode = !isKioskMode;
    if (isKioskMode)  setIsKiosk(true);
    if (isOnlineMode) setIsOnline(true);

    // Kiosk gépen kezdőképernyő, weben rögtön rendelés
    // Online módban home képernyő jelenik meg (nem ugrik egyből a rendelésre)

    if (payment === 'success' && orderRef) {
      setReturnOrderRef(orderRef);
      setScreen('order');
      setStep(isOnlineMode ? 6 : 5);
    } else if (payment && payment !== 'success') {
      setPayEvent(payment); setPayError(true);
      setScreen('order');
      setStep(isOnlineMode ? 6 : 5);
    }
    if (payment || mode || kiosk) window.history.replaceState({}, '', window.location.pathname + (kiosk ? '?kiosk=true' : ''));
  // eslint-disable-next-line
  }, []);

  function addToCart() {
    if (!size || !flavor || sauce === undefined || topping === undefined) return;
    setCart(c => [...c, { size, flavor, sauce, topping,
      total: size.price + sauce.price + topping.price }]);
    setSize(null); setFlavor(null); setSauce(undefined); setTopping(undefined);
    setStep(4);
  }

  function removeFromCart(idx) { setCart(c => c.filter((_,i) => i !== idx)); }

  function handlePaymentSuccess(data) {
    speak(voicePrompts.paymentSuccess);
    setCodeRedeemMode(false);
    setReceiptData(data);
    setStep(isOnline ? 7 : 6);
  }

  function handleCodeRedeemed(data) {
    // Kóddal beváltott rendelés → robot indul → elkészítés képernyő
    speak(voicePrompts.codeAccepted);
    setCodeRedeemMode(true);
    setReceiptData(data);
    setCart(data.cart || []);
    setScreen('order');
    setStep(7); // Kódos átvétel: Nyugta oldal kihagyása, közvetlen Készítés
  }

  function restart() {
    setStep(0); setSize(null); setFlavor(null); setSauce(undefined); setTopping(undefined);
    setCoupon(null);
    try { sessionStorage.removeItem('csavarosCoupon'); } catch(e) {}
    setCart([]); setEmail(''); setPayError(false); setPayEvent(null);
    setReceiptData(null); setReturnOrderRef(null); setCodeRedeemMode(false);
    if (isKiosk) setScreen('home');
  }

  const currentConfig = { size, flavor, sauce, topping };

  function startSingleSizeOrder() {
    const firstSize = sizes && sizes.length ? sizes[0] : DEFAULT_SIZES[0];
    setSize(firstSize);
    setFlavor(null);
    setSauce(undefined);
    setTopping(undefined);
    setStep(1);
  }

  return (
    <div className="app-bg">
      <div className="kiosk-shell">
        <Topbar total={cartTotal} isOnline={isOnline} isKiosk={isKiosk} screen={screen} onHome={() => { restart(); if(isKiosk) setScreen("home"); else window.location.reload(); }}/>

        {/* ── KIOSK NYITÓKÉPERNYŐ ── */}
        {screen === 'home' && !isKiosk && (
          <div className="main-layout single">
            <div className="main-panel" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
              <OnlineHomeScreen
                onNewOrder={() => { enableVoice(); speak(voicePrompts.startOrder); setCodeRedeemMode(false); setScreen('order'); setStep(0); }}
              />
            </div>
          </div>
        )}
        {screen === 'home' && isKiosk && (
          <div className="main-layout single">
            <div className="main-panel" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
              <KioskHomeScreen
                onNewOrder={() => {
                  enableVoice();
                  speak(voicePrompts.startOrder);
                  setCodeRedeemMode(false);
                  setScreen('order');
                  setStep(0);
                }}
                onHaveCode={() => {
                  enableVoice();
                  speak(voicePrompts.haveCode);
                  setCodeRedeemMode(true);
                  setScreen('redeem');
                }}
              />
            </div>
          </div>
        )}

        {/* ── KÓD BEVÁLTÓ ── */}
        {screen === 'redeem' && (
          <div className="main-layout single">
            <div className="main-panel" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
              <CodeRedeemScreen
                onBack={() => {
                  stopSpeak();
                  setCodeRedeemMode(false);
                  setScreen('home');
                }}
                onSuccess={handleCodeRedeemed}
              />
            </div>
          </div>
        )}

        {/* ── RENDELÉSI FLOW ── */}
        {screen === 'order' && (
          <>
            <ProgressBar step={step} isOnline={isOnline}/>
            <div className={`main-layout${showSidebar ? '' : ' single'}`}>
              <div className="main-panel">

                {step === 0 && <>
                  <StartOrderStep
                    size={sizes && sizes.length ? sizes[0] : DEFAULT_SIZES[0]}
                    isKiosk={isKiosk}
                    onStart={startSingleSizeOrder}
                    onBackHome={() => setScreen('home')}
                  />
                </>}

                {step === 1 && <>
                  <FlavorStep flavors={flavors} selected={flavor} onSelect={f => { setFlavor(f); setStep(2); }}/>
                  <div className="bottom-nav">
                    <button className="secondary-action big" onClick={() => setStep(0)}>← Vissza</button>
                    <button className="primary-action big" disabled={!flavor} onClick={() => setStep(2)}>Tovább → Öntet</button>
                  </div>
                </>}

                {step === 2 && <>
                  <SauceStep sauces={sauces} selected={sauce} onSelect={s => { setSauce(s); setStep(3); }}/>
                  <div className="bottom-nav">
                    <button className="secondary-action big" onClick={() => setStep(1)}>← Vissza</button>
                    <button className="primary-action big" disabled={sauce === undefined} onClick={() => setStep(3)}>Tovább → Szórás</button>
                  </div>
                </>}

                {step === 3 && <>
                  <ToppingStep toppings={toppings} selected={topping} onSelect={t => { setTopping(t); }}/>
                  <div className="bottom-nav">
                    <button className="secondary-action big" onClick={() => setStep(2)}>← Vissza</button>
                    <button className="primary-action big" disabled={topping === undefined} onClick={addToCart}>➕ Kosárba</button>
                  </div>
                </>}

                {step === 4 && <>
                  <CartStep items={cart} onRemove={removeFromCart} coupon={coupon} onCouponApply={setCoupon} isKiosk={isKiosk}/>
                  <div className="bottom-nav">
                    <button className="secondary-action big" onClick={() => setStep(0)}>+ Még egyet</button>
                    <button className="primary-action big" disabled={cart.length === 0}
                      onClick={() => {
                        if (coupon) {
                          try {
                            sessionStorage.setItem('csavarosCoupon', JSON.stringify(coupon));
                          } catch (e) {}
                        } else {
                          try {
                            sessionStorage.removeItem('csavarosCoupon');
                          } catch (e) {}
                        }

                        console.log('PAY BUTTON coupon:', coupon);

                        setCodeRedeemMode(false);
                        setPayError(false);
                        setPayEvent(null);
                        speak(isOnline ? (voicePrompts.email || "Add meg az email címedet.") : voicePrompts.scanQr);
                        setStep(isOnline ? 5 : payStep);
                      }}>
                      💳 Fizetés ({fmt(cartTotal)})
                    </button>
                  </div>
                </>}

                {isOnline && step === 5 && <>
                  <EmailStep email={email} onChange={setEmail}/>
                  <div className="bottom-nav" style={{ justifyContent:'center' }}>
                    <button className="secondary-action big" onClick={() => setStep(4)}>← Vissza</button>
                    <button className="primary-action big"
                      disabled={!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
                      onClick={() => {
                        setPayError(false);
                        speak(voicePrompts.paymentChecking || voicePrompts.scanQr);
                        setStep(6);
                      }}>
                      Tovább → Fizetés
                    </button>
                  </div>
                </>}

                {step === payStep && !payError && (
                  <PaymentStep cart={cart} total={cartTotal} coupon={coupon}
                    customerEmail={isOnline ? email : undefined}
                    isOnline={isOnline} isKiosk={isKiosk}
                    orderRef={returnOrderRef}
                    onPaid={handlePaymentSuccess}
                    onError={() => setPayError(true)}/>
                )}

                {step === payStep && payError && (
                  <ErrorStep payEvent={payEvent}
                    onRetry={() => { setPayError(false); setPayEvent(null); setReturnOrderRef(null); setStep(payStep); }}
                    onRestart={restart}/>
                )}

                {!isOnline && !codeRedeemMode && step === 6 && (
                  <KioskReceiptStep orderRef={receiptData?.orderRef} onDone={() => {
                    speak(voicePrompts.robotWorking);
                    setStep(7);
                  }}/>
                )}

                {!isOnline && step === 7 && (
                  <PreparingStep cart={cart} orderRef={receiptData?.orderRef} onDone={() => {
                    speak(voicePrompts.finished);
                    setStep(8);
                  }}/>
                )}

                {!isOnline && step === 8 && (
                  <SuccessStep orderCode={receiptData?.orderRef || '—'} cart={cart}
                    receiptQrUrl={null} onRestart={restart}/>
                )}

                {isOnline && step === 7 && (
                  <OnlineConfirmStep code={receiptData?.code || '——————'} orderRef={receiptData?.orderRef}/>
                )}

              </div>

              {showSidebar && <CartSidebar step={step} items={cart} currentConfig={currentConfig}/>}
            </div>
          </>
        )}

      </div>
    </div>
  );
}
